import React from 'react';
import PropTypes from 'prop-types';
import {InputAdornment, TextField} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import {bgColorRequester, bgColorSpender} from '../../../_helpers';

/**
 * Generic field that can only be edited when opening a popup.
 *
 * @param {PopupField.propTypes} props
 * @return {JSX.Element}
 */
export function PopupField(props) {
    const hasValue = props.value !== undefined && props.value.length > 0 && !props.showMultiple;
    return (<TextField
        sx={{
            backgroundColor: props.mandatoryForSpender && props.highlightMandatoryFieldForSpender ?
                bgColorSpender :
                props.mandatoryForRequester && props.highlightMandatoryFieldForRequester?
                    bgColorRequester :
                    null,
        }}
        fullWidth
        disabled
        variant={'standard'}
        value={hasValue ? props.value : (props.placeholder || '')} // display placeholder text as value (not in a faded color)
        InputProps={{
            sx: props.optionsLength > 1 ? {
                '.css-1x51dt5-MuiInputBase-input-MuiInput-input.Mui-disabled': {
                    'WebkitTextFillColor': 'rgba(0, 0, 0, 0.87)',
                    'color': 'rgba(0, 0, 0, 0.87)',
                },
            } : undefined,
            startAdornment: ( props.loading &&
                <InputAdornment position="start">
                    <CircularProgress size={20} />
                </InputAdornment>
            ),
            endAdornment: <InputAdornment position="end">
                {hasValue && props.canEdit && props.onClear !== undefined && (props.property !== 'Partner functions' || props.optionsLength > 1) &&
                    <IconButton onClick={props.onClear} edge="end">
                        <CloseIcon/>
                    </IconButton>
                }
                {props.canEdit && props.onOpen !== undefined && (props.property !== 'Partner functions' || props.optionsLength > 1) &&
                    <IconButton onClick={props.onOpen} edge="end">
                        <EditIcon/>
                    </IconButton>
                }
            </InputAdornment>,
        }}
    />);
}

PopupField.propTypes = {
    showMultiple: PropTypes.bool,
    optionsLength: PropTypes.number,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    loading: PropTypes.bool,
    canEdit: PropTypes.bool,
    onOpen: PropTypes.func,
    onClear: PropTypes.func,
    property: PropTypes.string,
    mandatoryForSpender: PropTypes.bool,
    mandatoryForRequester: PropTypes.bool,
    highlightMandatoryFieldForRequester: PropTypes.bool,
    highlightMandatoryFieldForSpender: PropTypes.bool,
};
